import { createRootRoute, createRoute, Outlet } from '@tanstack/react-router'

import { AuthGateLayout, DashboardLayout, AdminLayout } from './layouts'

export const rootRoute = createRootRoute({ component: () => <Outlet /> })

export const authGateRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'auth-gate',
  component: AuthGateLayout,
})

export const dashboardRoute = createRoute({
  getParentRoute: () => authGateRoute,
  id: 'dashboard',
  component: DashboardLayout,
})

export const adminRoute = createRoute({
  getParentRoute: () => dashboardRoute,
  path: 'admin',
})

export const adminLayoutRoute = createRoute({
  getParentRoute: () => adminRoute,
  id: 'admin-layout',
  component: AdminLayout,
})
